import {wymsFetch, getParams} from '@/utils/fetch';

// 查询菜单树
export function queryPermissionByName(args) {
    const params = getParams(true, args);
    params.append('name', args.name);

    return wymsFetch({
        url: 'permission/queryPermissionByName',
        method: 'GET',
        params
    });
}

// 查询菜单树层次
export function queryPermissionTree(args) {
    const params = getParams(true, args);
    params.append('menu', args.menu);

    return wymsFetch({
        url: 'permission/queryPermissionTree',
        method: 'GET',
        params
    });
}

// 权限资源详情
export function queryPermission(args) {
    const params = getParams();
    params.append('id', args.id);

    return wymsFetch({
        url: 'permission/queryPermission',
        method: 'GET',
        params
    });
}
// 新增菜单
export function insertPermission(args) {
    const params = getParams();
    params.append('description', args.description);
    params.append('label', args.label);
    params.append('moduleId', args.moduleId);
    params.append('name', args.name);
    params.append('pid', args.pid);
    params.append('systemType', args.systemType);
    params.append('url', args.url);
    params.append('type', args.type);

    return wymsFetch({
        url: 'permission/insertPermission',
        method: 'POST',
        data: params
    });
}

// 查询模块列表
export function queryModuleByModel() {
    return wymsFetch({
        url: 'permission/queryModuleByModel',
        method: 'GET',
    });
}

// 查询系统类型
export function querySysMenuType() {
    return wymsFetch({
        url: 'permission/querySysMenuType',
        method: 'GET',
    });
}
// 菜单移动排序
export function movingSort(args) {
    const params = getParams();
    params.append('id', args.id);
    params.append('sort', args.sort);

    return wymsFetch({
        url: 'permission/movingSort',
        method: 'POST',
        data: params
    });
}
// 删除权限
export function delPermission(args) {
    const params = getParams();
    params.append('ids', args.ids);

    return wymsFetch({
        url: 'permission/delPermission',
        method: 'GET',
        params
    });
}
//编辑权限
export function updatePermission(args) {
    const params = getParams();
    params.append('description', args.description);
    params.append('label', args.label);
    params.append('moduleId', args.moduleId);
    params.append('name', args.name);
    params.append('pid', args.pid);
    params.append('id', args.id);
    params.append('url', args.url);
    params.append('type', args.type);

    return wymsFetch({
        url: 'permission/updatePermission',
        method: 'POST',
        data: params
    });
}

// 权限资源表格
export function queryPermissionByPid(args) {
    const params = getParams(true, args);
    params.append('id', args.id);
    params.append('names', args.names);

    return wymsFetch({
        url: 'permission/queryPermissionByPid',
        method: 'GET',
        params
    });
}

//查询角色统计
export function queryRolePermGrant(args) {

    const params = getParams();
    params.append('id', args.id);

    return wymsFetch({
        url: 'permission/queryRolePermGrant',
        method: 'POST',
        data: params
    });
}



// WEBPACK FOOTER //
// ./src/api/permission.js